export default __webpack_public_path__ + "images/UR.1c02598.png";